export default __webpack_public_path__ + "static/media/coracle.50f71844.svg";